import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ButtonAction } from "shared/components/ButtonAction";
import { accesRoles } from "shared/models";
import "../../read-documents/styles/_menuFunctions.scss";
import { IExportedPackage } from "../types";

interface Props {
  packageData: IExportedPackage;
  onViewDetail: (packageData: IExportedPackage) => void;
  onRevertExport: (packageData: IExportedPackage) => void;
  onDownloadZip: (packageData: IExportedPackage) => void;
  onLoadPaymentInfo: (packageData: IExportedPackage) => void;
  onDownloadDraftResolution: (packageData: IExportedPackage) => void;
}

export const MenuActionsExportedPackages = ({
  packageData,
  onViewDetail,
  onRevertExport,
  onDownloadZip,
  onLoadPaymentInfo,
  onDownloadDraftResolution,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpenFunctions = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewDetail = () => {
    onViewDetail(packageData);
    handleClose();
  };

  const handleRevertExport = () => {
    onRevertExport(packageData);
    handleClose();
  };

  const handleDownloadZip = () => {
    onDownloadZip(packageData);
    handleClose();
  };

  const handleLoadPaymentInfo = () => {
    onLoadPaymentInfo(packageData);
    handleClose();
  };

  const handleDownloadDraftResolution = () => {
    onDownloadDraftResolution(packageData);
    handleClose();
  };

  return (
    <section className={"MenuFunctions"}>
      <IconButton
        data-testid={`buttonFunctions-${packageData.id}`}
        onClick={handleClick}
      >
        Acciones <ExpandMore />
      </IconButton>
      <Menu
        id={`menu-options-${packageData.id}`}
        data-testid={`menuOptions-${packageData.id}`}
        className={"menuOptions"}
        anchorEl={anchorEl}
        open={isOpenFunctions}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        marginThreshold={0}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 220,
            maxWidth: "calc(100vw - 32px)",
          },
        }}
      >
        <MenuItem>
          <ButtonAction
            roles={accesRoles.financialModule}
            disabled={false}
            dataTestid={`view-detail-${packageData.id}`}
            action={handleViewDetail}
          >
            <span>Ver detalle</span>
          </ButtonAction>
        </MenuItem>
        {packageData.exportStatus !== "Pagado" && (
          <MenuItem>
            <ButtonAction
              roles={accesRoles.financialModule}
              disabled={packageData.exportStatus === "Revertido"}
              dataTestid={`revert-export-${packageData.id}`}
              action={handleRevertExport}
            >
              <span>Revertir exporte de pago</span>
            </ButtonAction>
          </MenuItem>
        )}
        {packageData.exportStatus !== "Pagado" && (
          <MenuItem>
            <ButtonAction
              roles={accesRoles.financialModule}
              disabled={false}
              dataTestid={`load-payment-info-${packageData.id}`}
              action={handleLoadPaymentInfo}
            >
              <span>Cargar información de pago</span>
            </ButtonAction>
          </MenuItem>
        )}
        <MenuItem>
          <ButtonAction
            roles={accesRoles.financialModule}
            disabled={false}
            dataTestid={`download-zip-${packageData.id}`}
            action={handleDownloadZip}
          >
            <span>Descargar ZIP</span>
          </ButtonAction>
        </MenuItem>
        <MenuItem>
          <ButtonAction
            roles={accesRoles.finance}
            disabled={false}
            dataTestid={`download-draft-resolution-${packageData.id}`}
            action={handleDownloadDraftResolution}
          >
            <span>Descargar Preforma Resolución</span>
          </ButtonAction>
        </MenuItem>
      </Menu>
    </section>
  );
};
